import { catalogsSyncTypes } from "./catalogsSyncTypes";

const {
  SYNC_CATALOGS_SYNC,
  CLEAR_CATALOGS_SYNC,
} = catalogsSyncTypes

const INITIAL_STATE = {
  isError: false,
  catalogsSyncLog: "",
  catalogsSync: {}
}

export const catalogsSyncReducer = (state = INITIAL_STATE, {type, payload}) => {

  switch (type) {

    case SYNC_CATALOGS_SYNC:
      return {
        ...state,
        isError: payload?.isError,
        catalogsSyncLog: payload?.catalogsSyncLog,
        catalogsSync: payload?.catalogsSync
      }

    case CLEAR_CATALOGS_SYNC:
      return {
          ...state,
          ...INITIAL_STATE,
      };
  
    default :
      return state
  }
}